// Shared path validation helpers used by ArticleGenerator.vue and KnowledgeConfiguration.vue #20260522KL

const WINDOWS_DRIVE_RE = /^[A-Za-z]:[/\\]/
const UNC_PATH_RE = /^\\\\[^\\]+\\[^\\]+/
const INVALID_CHARS_RE = /[<>"|?*]/
const WINDOWS_DRIVE_PREFIX_RE = /^[A-Za-z]:/
const UNC_PREFIX_RE = /^\\\\.+?\\/

export const isWindowsDrivePath = (path) => WINDOWS_DRIVE_RE.test(path)
export const isUNCPath = (path) => UNC_PATH_RE.test(path)
export const hasValidPathChars = (path) =>
  !INVALID_CHARS_RE.test(path.replace(WINDOWS_DRIVE_PREFIX_RE, '').replace(UNC_PREFIX_RE, ''))
